import { type MenuPrivate } from '../entities/MenuPrivate'

export const MenuPrivateOwnerCalendar = 'calendar'
export const MenuPrivateOwnerMessages = 'messages'
export const MenuPrivateOwnerAccomodations = 'accommodations'
export const MenuPrivateOwnerPremiumServices = 'premium_services'

const menu: MenuPrivate = [
  {
    id: MenuPrivateOwnerCalendar,
    name: 'menu.private_menu.calendar',
    href: '/owner/:id/calendar-quick/rent-unit',
    icon: 'i-heroicons-calendar-days',
    selected: false,
    unread: 0,
  },
  {
    id: 'bookings',
    name: 'menu.private_menu.bookings',
    href: '/propietario/:id/reserva/lista',
    icon: 'i-heroicons-key',
    selected: false,
    unread: 0,
  },
  {
    id: MenuPrivateOwnerMessages,
    name: 'menu.private_menu.messages',
    href: '/owner/:id/menu/messages',
    icon: 'i-heroicons-chat-bubble-left-ellipsis',
    selected: false,
    unread: 0,
  },
  {
    id: MenuPrivateOwnerAccomodations,
    name: 'menu.private_menu.accommodations',
    href: '/propietario/:id/menu/alojamientos',
    icon: 'i-heroicons-home',
    selected: false,
    unread: 0,
  },
  {
    id: 'payment_platform',
    name: 'menu.private_menu.payment_platform',
    href: '/owner/:id/online-booking/config',
    icon: 'i-heroicons-credit-card',
    selected: false,
    unread: 0,
  },
  {
    id: MenuPrivateOwnerPremiumServices,
    name: 'menu.private_menu.premium_services',
    href: '/propietario/:id/menu/servicios',
    icon: 'i-heroicons-star',
    selected: false,
    unread: 0,
  },
  {
    id: 'webpage',
    name: 'menu.private_menu.webpage',
    href: '/owner/:id/website',
    icon: 'i-heroicons-computer-desktop',
    selected: false,
    unread: 0,
  },
  {
    id: 'helpCenterWhatsapp',
    name: 'menu.private_menu.helpCenterWhatsapp',
    href: '',
    icon: 'i-ic-baseline-whatsapp',
    selected: false,
    unread: 0,
  },
  {
    id: 'helpCenter',
    name: 'menu.private_menu.helpCenter',
    href: 'https://ayuda.escapadarural.com/hc/es',
    icon: 'i-heroicons-question-mark-circle',
    selected: false,
    unread: 0,

    target: '_blank',
  },
  {
    id: 'phone',
    name: 'menu.private_menu.phone',
    href: 'tel:932458353',
    icon: 'i-heroicons-phone',
    selected: false,
    unread: 0,
  },
]

export default menu
